
import StepZero from '../pages/StepZero';
import LoginSignInPage from '../pages/LoginSignInPage';
import StepUploadImages from '../pages/StepUploadImages';
import DashboardPage from '../pages/DashboardPage';
import MyImages from '../pages/MyImages';
import PricingPage from '../component/Pricing';
import PlanDetails from '../pages/PlanDetails';
import PaymentSuccess from '../pages/PaymentSuccess';
import PaymentFailed from '../pages/PaymentFailed';


export const routesList = [
  {
    path: `/`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: StepZero,
  },
  {
    path: `/upload-images`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: StepUploadImages,
  },
  {
    path: `/dashboard`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: DashboardPage,
  },
  {
    path: `/login`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: LoginSignInPage,
  },
  {
    path: `/signup`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: LoginSignInPage,
  },
  {
    path: `/forgot-password`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: LoginSignInPage,
  },
  {
    path: `/subscription`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: PricingPage,
  },
  {
    path: `/plan-details`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: PlanDetails,
  },
  {
    path: `/success`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: PaymentSuccess,
  },
  {
    path: `/failure`,
    title: 'Meta Model',
    exact: true,
    protected: true,
    component: PaymentFailed,
  },
  // {
  //   path: `/my-images/:id`,
  //   title: 'Meta Model',
  //   exact: true,
  //   protected: true,
  //   component: MyImages,
  // },
  // {
  //   path: `/my-images`,
  //   title: 'Meta Model',
  //   exact: true,
  //   protected: true,
  //   component: MyImages,
  // },
  
 
];
